const initialState =  {
    menuOpen: null,
}

export default initialState;